import React, { FC } from 'react';
import Typography from '@material-ui/core/Typography';

interface Props {
    value: string;
    className?: string;
}

const STitle: FC<Props> = p => {

    return (
        <>
            <Typography
                align="center"
                variant="overline" 
                display="block"
                className={p.className}
            >
                {p.value}
            </Typography>
        </>
    );
}

export default STitle;
